import cx from 'classnames';
import { CircularLoadingSpinner } from 'lib/CircularLoadingSpinner/CircularLoadingSpinner';

type Props = {
  isLoading?: boolean;
  isFixed?: boolean;
};

const Preloader = ({ isLoading = true, isFixed = false }: Props): React.ReactElement | null => {
  if (!isLoading) return null;

  return (
    <div
      className={cx('w-full h-full top-0 bottom-0 left-0 right-0 m-auto bg-neutral-950-opacity-10 z-80', {
        fixed: isFixed,
        absolute: !isFixed,
      })}
      data-test-id="loader-container"
    >
      <CircularLoadingSpinner />
    </div>
  );
};

export default Preloader;
